import styled from 'styled-components';

export const IconWrapper = styled.div<{ $bottom: number; $right: number }>`
  position: absolute;
  z-index: 1;
  bottom: ${({ $bottom }) => $bottom}px;
  right: ${({ $right }) => $right}px;

  &:hover {
    cursor: pointer;
    transform: scale(1.25);
  }
`;
